import React from 'react';
import clsx from 'clsx';

// @material-ui/core components
import { Box, Typography, Icon } from '@material-ui/core';

// sdk
import { ORDER_STATUS } from '@sdk-point/talisis';

const PaymentStatus = ({ order }) => {
    let classValue = {
        name: "",
        color: "",
        icon: "",
    };

    if (order.status_id === ORDER_STATUS.PENDING_PAYMENT || order.status_id === ORDER_STATUS.PENDING_PAYMENT_3DS ) {
        classValue.name = "Pago pendiente";
        classValue.color = "text-warning-300";
        classValue.icon = "ri-loader-2-fill";
    } else if (order.status_id === ORDER_STATUS.COMPLETED_PAYMENT) {
        classValue.name = "Pago exitoso";
        classValue.color = "text-success-300";
        classValue.icon = "ri-checkbox-circle-fill";
    }

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <Icon className={clsx(classValue.icon, classValue.color)} style={{ fontSize: "32px", marginRight: "18.6px" }} />
            <Typography variant="h2" className={clsx(classValue.color)} color="primary">{classValue.name}</Typography>
        </Box>
    );
};


export default PaymentStatus;